module.exports = __webpack_public_path__ + "static/pcab-d0b730fb4255975f08cbd327a8de14e9.png";